/* Product carousel — horizontal scroll with prev/next arrows.
   Scrolls one card at a time and disables arrows at the track ends. */

class ProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('[data-pc-track]');
    this.prev = this.querySelector('[data-pc-prev]');
    this.next = this.querySelector('[data-pc-next]');
  }

  connectedCallback() {
    if (!this.track) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.behavior = reduceMotion ? 'auto' : 'smooth';

    if (this.prev) this.prev.addEventListener('click', () => this.scrollByCard(-1));
    if (this.next) this.next.addEventListener('click', () => this.scrollByCard(1));

    this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
    window.addEventListener('resize', () => this.updateArrows());

    this.updateArrows();
  }

  step() {
    const card = this.track.querySelector('.pc-card');
    if (!card) return this.track.clientWidth;
    const gap = parseInt(getComputedStyle(this.track).columnGap, 10) || 0;
    return card.offsetWidth + gap;
  }

  scrollByCard(direction) {
    this.track.scrollBy({ left: this.step() * direction, behavior: this.behavior });
  }

  updateArrows() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    if (this.prev) this.prev.disabled = this.track.scrollLeft <= 1;
    if (this.next) this.next.disabled = this.track.scrollLeft >= max - 1;
  }
}

customElements.define('product-carousel', ProductCarousel);
